<div class="d-flex flex-column">
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<span class="p-float-label mt-4 w-100">
				<input
					pInputText
					#venueNameInput
					name="venueNameInput"
					type="text"
					[(ngModel)]="venue.name"
					class="w-100"
					(change)="changesToSaveChange.emit(true)"
				/>
				<label for="venueNameInput">Venue Name</label>
			</span>
		</div>
		<div class="p-col-12 p-md-6">
			<span class="p-float-label mt-4">
				<input
					pInputText
					#externalBusinessId
					name="externalBusinessId"
					type="text"
					[(ngModel)]="venue.externalBusinessId"
					class="w-100"
					(change)="changesToSaveChange.emit(true)"
				/>
				<label for="externalBusinessId">Yelp Business ID</label>
			</span>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-4 d-flex">
			<div class="mx-auto"><p-inputSwitch [(ngModel)]="venue.active" (onChange)="changesToSaveChange.emit(true)"></p-inputSwitch> Active</div>
		</div>
		<div class="p-col-12 p-md-4 d-flex">
			<div class="mx-auto"><p-inputSwitch [(ngModel)]="venue.debug" (onChange)="changesToSaveChange.emit(true)"></p-inputSwitch> Debug Mode</div>
		</div>
		<div class="p-col-12 p-md-4 d-flex">
			<div class="mx-auto">
				<p-inputSwitch [(ngModel)]="venue.datafeedPollingEnabled" (onChange)="changesToSaveChange.emit(true)"></p-inputSwitch> Datafeed Pollling
			</div>
		</div>
	</div>
</div>
